import { render, staticRenderFns } from "./recipients-table-send.vue?vue&type=template&id=2b1afb22&scoped=true&"
import script from "./recipients-table-send.vue?vue&type=script&lang=js&"
export * from "./recipients-table-send.vue?vue&type=script&lang=js&"
import style0 from "./recipients-table-send.vue?vue&type=style&index=0&id=2b1afb22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1afb22",
  null
  
)

export default component.exports